import { useListItem, useMergeRefs } from '@floating-ui/react';
import { ChevronRight, Folder } from '@interhyp/platform-icons';
import React, { useContext } from 'react';
import { MenuContext } from "../../context/MenuContext.js";
import { isFilteredFolderItem } from "../../functions/isFilteredFolderItem.js";
import { ItemDivButton } from "../ItemButton/ItemButton.js";
import { ItemLabel } from "../ItemLabel/ItemLabel.js";
import styles from "./FolderButton.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FolderButtonConnected({
  folderItem,
  active,
  isOpen,
  getReferenceProps,
  refs
}) {
  const {
    parent
  } = useContext(MenuContext);
  const {
    ref
  } = useListItem();
  return /*#__PURE__*/_jsx(FolderButton, {
    folderItem: folderItem,
    buttonProps: {
      ref: useMergeRefs([refs.setReference, ref]),
      'aria-selected': active || isOpen,
      'aria-checked': folderItem.checked,
      role: 'menuitem',
      ...getReferenceProps(parent?.getItemProps())
    }
  });
}
export function FolderButton({
  folderItem,
  buttonProps = {}
}) {
  return /*#__PURE__*/_jsxs(ItemDivButton, {
    className: styles.folderButton,
    ...buttonProps,
    children: [folderItem.icon ?? /*#__PURE__*/_jsx(Folder, {}), /*#__PURE__*/_jsx("span", {
      className: styles.text,
      children: isFilteredFolderItem(folderItem) ? /*#__PURE__*/_jsx(ItemLabel, {
        label: folderItem.label,
        start: folderItem.highlightStart,
        end: folderItem.highlightEnd
      }) : folderItem.label
    }), /*#__PURE__*/_jsx(ChevronRight, {
      className: styles.arrow
    })]
  });
}